import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { HotkeysService } from 'angular2-hotkeys';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';

import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { OverlayService, NoticeDefinition } from '../../../services/overlay.service';
import { SapiService, SapiEntity } from '../../../services/sapi.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { ExportChannel } from '../../../interfaces/exportchannel';
import { BbSelectOption } from '../../shared/bb-select/bb-select.component';
import { LocationService } from '../../../services/location.service';

@Component({
	selector: 'social-details-instagram',
	templateUrl: './social-details-instagram.component.html',
	styleUrls: ['./social-details-instagram.component.scss']
})


export class SocialDetailsInstagramComponent extends AbstractDetailsComponent implements OnInit {

	@ViewChild('formRef', { static: true }) form: NgForm;

	channel: ExportChannel;
	preview: boolean;
	previewActive = false;
	accountOptions: BbSelectOption[] = [];

	entity: ExportChannel;

	constructor(protected overlayService: OverlayService,
		protected location: Location,
		protected sapiService: SapiService,
		protected translate: TranslateService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected hotkeysService: HotkeysService,
		protected authenticationService: AuthenticationService,
		private locationService: LocationService) {

		super(route, location);

		this.entityConfiguration = {
			name: 'exportchannel',
			entityTranslation: this.translate.instant('INSTAGRAM_CHANNEL'),
			defaults: {
				exportsystemid: 5,
				exportsystemname: 'Instagram',
				subtype: 'Instagram'
			},
			entityType: 'Exportchannel',
			parentPath: '/library/social',
			basePath: '/library/social/instagram/'
		};
	}

	ngOnInit() {
		super.ngOnInit();

		this.route.params.subscribe((params: Params) => {
			this.previewActive = (params.tab === 'synced');
		});

		(window as any).socialCallback = (status: string, token_id: string) => {
			if (status === 'ok') {

				(this.entity as ExportChannel).authtokenid = token_id;
				this.overlayService.createToast(this.translate.instant('SOCIAL_AUTHENTICATION_SUCCESSFUL'), 'check');
				this.save();
			} else {
				const notice: NoticeDefinition = {
					icon: 'warning',
					title: this.translate.instant('ERROR'),
					type: 'error',
					contents: this.translate.instant('SOCIAL_AUTHENTICATION_ERROR')
				};

				this.overlayService.createNotice(notice);
			}
		};
	}

	load(id: string, duplicating?: boolean): Observable<SapiEntity> {
		const observable = super.load(id, duplicating);

		observable.subscribe(() => {
			this.loadAccounts();
		});

		return observable;
	}

	save(force: boolean = false): Observable<void> {

		const subject = super.save(force, null, false);
		subject.subscribe(() => {
			if (this.isNew) {
				this.router.navigate([this.entityConfiguration.basePath, this.entity.id, 'general']);
			}
			this.loadAccounts();
		});

		return subject;
	}

	loadAccounts() {
		const url = '/exportchannel/' + this.entity.id + '/accounts';

		this.sapiService.getUrl(url).subscribe(data => {
			this.entity.name = data.name;
			const accountOptions: BbSelectOption[] = [];

			if (typeof data.accounts !== 'undefined' && data.accounts.length) {
				for (const account of data.accounts) {
					if (!account.instagram) {
						accountOptions.push({
							value: account.id,
							label: account.name,
							disabled: true
						});
					} else {
						accountOptions.push({
							value: account.id,
							label: account.name,
							disabled: false
						});
						if (this.entity.instagramId === undefined) {
							this.entity.instagramId = account.instagram.id;
						}
					}
					if (this.entity.remotePageId === undefined || this.entity.remotePageTitle === undefined) {
						for (let i = 0; i < accountOptions.length; i++ ) {
							if (!accountOptions[i].disabled) {
								this.entity.remotePageId = accountOptions[i].value;
								this.entity.remotePageTitle = accountOptions[i].label;
							}
						}
					}
				}
			}
			this.accountOptions = accountOptions;
		});
	}

	onPageSelected(page) {
		this.entity.remotePageId = page.value;
		this.entity.remotePageTitle = page.label;
	}

	authenticate() {
		const url = this.locationService.server +
			'/sapi/exportchannel/' + (this.entity && this.entity.id ? this.entity.id + '/' : '') + 'authorize/instagram';

		(window as any).open(url, 'authenticate', 'location=0, height=400, width=580');
	}
}
